import { fieldDefinitionDecorator } from '../../Shared/FieldDefinition/FieldDefinitionDecorator';
import { SystemFieldDefinitions } from '../../Shared/FieldDefinition';

export class BaseContainerElement {

    @fieldDefinitionDecorator(SystemFieldDefinitions.Pub.HelpText)
    helpText: string;
    
}
